export default "__VITE_ASSET__DGUPY8Lb__"